import styled from "@emotion/styled";
import InnoIcons from "InnoUI/innoicons";

const Container = styled.div``;
const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #feedde;
  height: 45px;
`;

const WarningIcon = styled(InnoIcons.WarningIcon)`
  margin-right: 5px;
  color: #ac2010;
`;
const WarningMessage = styled.span`
  font-size: 14px;
  color: #ac2010;
`;
const MessageDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;
const MessageData = styled.span`
  font-size: 15px;
  color: black;
`;

const ButtonContiner = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px;
`;

const SC = {
  Container,
  WarningContainer,
  WarningIcon,
  MessageData,
  WarningMessage,
  MessageDataContainer,
  ButtonContiner,
};

export default SC;
